module.exports = "/static/assets/98fb2b55ace28b640bdb0f160a7109fd.png";